import script from "./TreeViewCategoria.vue?vue&type=script&setup=true&lang=js"
export * from "./TreeViewCategoria.vue?vue&type=script&setup=true&lang=js"

import "./TreeViewCategoria.vue?vue&type=style&index=0&id=cb889f7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-cb889f7a"]])

export default __exports__